import { useState } from 'react';

import {
  ActionDialogButtons,
  ActionDialogContent,
  Button,
  Dialog,
  DialogContent,
  ThemeToggleButton,
  UserMenu,
  UserMenuItem,
} from '@opositandopn/ui';
import {
  IoInformationCircleOutline,
  IoLogOutOutline,
  IoMoonOutline,
  IoPersonCircleOutline,
  IoSettingsOutline,
} from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { useWindowSize } from 'usehooks-ts';

import { useAuth } from '../../../context/AuthContext';
import { useConfiguration } from '../../../context/ConfigurationContext';
import { useProfile } from '../../../context/ProfileContext';
import { useTheme } from '../../../context/ThemeContext';

import styles from './UserOptions.module.scss';

function UserOptions() {
  const navigate = useNavigate();
  const { auth } = useAuth();
  const { width } = useWindowSize();
  const { profile } = useProfile();
  const { configuration } = useConfiguration();
  const { theme, setTheme } = useTheme();

  const [logoutWarning, setLogoutWarning] = useState(false);

  async function logout() {
    setLogoutWarning(false);
    auth.signOut();
    navigate('/');
  }

  const toggleTheme = () => setTheme(theme === 'dark' ? 'light' : 'dark');

  return (
    <>
      <UserMenu
        username={profile.username ?? undefined}
        email={profile.email ?? undefined}
        avatarUrl={profile.avatarUrl ? profile.avatarUrl : undefined}
        avatarSize={width > 576 ? 'sm' : 'xs'}
      >
        {(close) => (
          <>
            <UserMenuItem
              icon={<IoPersonCircleOutline />}
              onClick={() => {
                window.open(
                  `${configuration.app?.pageUrl}/mi-cuenta`,
                  '_blank',
                );
              }}
            >
              Mi cuenta
            </UserMenuItem>
            <UserMenuItem
              icon={<IoSettingsOutline />}
              onClick={() => {
                window.open(
                  `${configuration.app?.pageUrl}/mi-cuenta/ajustes`,
                  '_blank',
                );
              }}
            >
              Ajustes
            </UserMenuItem>
            <UserMenuItem
              icon={<IoLogOutOutline />}
              onClick={() => {
                close();
                setLogoutWarning(true);
              }}
            >
              Cerrar sesión
            </UserMenuItem>
            <UserMenuItem
              icon={<IoInformationCircleOutline />}
              onClick={() => {
                navigate('/info');
                close();
              }}
            >
              Información
            </UserMenuItem>
            <UserMenuItem
              icon={<IoMoonOutline />}
              onClick={toggleTheme}
              suffix={
                <div className={styles['suffix']}>
                  <ThemeToggleButton
                    className={styles['theme-toggle']}
                    checked={theme === 'dark'}
                    onToggle={toggleTheme}
                  />
                </div>
              }
            >
              Modo oscuro
            </UserMenuItem>
            {profile.subscription?.isActive &&
              profile.subscription?.isTrial && (
                <Button
                  className={styles['button']}
                  variant="outline-premium"
                  onClick={() => {
                    window.open(
                      `${configuration.app?.pageUrl}/mi-cuenta`,
                      '_blank',
                    );
                  }}
                >
                  Suscripción de prueba
                </Button>
              )}
            {!profile.subscription?.isActive &&
              !profile.subscription?.isTrial && (
                <Button
                  className={styles['button']}
                  variant="premium"
                  shadow={true}
                  onClick={() => {
                    window.open(
                      `${configuration.app?.pageUrl}/mi-cuenta/premium`,
                      '_blank',
                    );
                  }}
                >
                  Hazte Premium
                </Button>
              )}
          </>
        )}
      </UserMenu>
      <Dialog open={logoutWarning} onOpenChange={setLogoutWarning}>
        <DialogContent>
          <ActionDialogContent
            icon={<IoLogOutOutline />}
            title="¿Estás segurx de cerrar la sesión?"
          >
            <ActionDialogButtons>
              <Button
                variant="outline-primary"
                onClick={() => setLogoutWarning(false)}
              >
                Cancelar
              </Button>
              <Button variant="danger" onClick={logout}>
                Salir
              </Button>
            </ActionDialogButtons>
          </ActionDialogContent>
        </DialogContent>
      </Dialog>
    </>
  );
}

export { UserOptions };
